import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import { useLazyGetSubscriptionQuery } from "../../services/subscription";
import { useEffect, useState } from "react";

const SubscriptionList = (props: any) => {
  const { searchItem } = props || ''
  const navigate = useNavigate();
  const [getSubscripton] = useLazyGetSubscriptionQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  console.log(debouncedSearchTerm, 'debouncedSearchTerm', searchItem)
  // ✅ Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchItem);
    }, 500); // delay 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchItem]);

  const getSubscriptonList = async () => {
    setIsLoading(true);
    try {
      const response = await getSubscripton({
        search: debouncedSearchTerm,
      }).unwrap();

      if (response?.status === 200) {
        // ✅ Ensure it's always an array
        const subscriptionData = Array.isArray(response?.data)
          ? response.data
          : response?.data?.items || [];

        setData(subscriptionData);
        setTotalCount(subscriptionData.length);
      } else {
        setData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSubscriptonList();
  }, [debouncedSearchTerm]);


  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Plan Name</TableCell>
            <TableCell>Trial Period</TableCell>
            <TableCell>Monthly Price</TableCell>
            <TableCell>Yearly Price</TableCell>
            <TableCell>Created Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!isLoading && data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} align="center">No data available</TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell onClick={() => navigate("/manage-subscriptions/detail")} className="click_action"><strong>{row.plan}</strong></TableCell>
                <TableCell>{row.trial}</TableCell>
                <TableCell>{row.monthlyAmount}</TableCell>
                <TableCell>{row.yearlyAmount}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell><SwitchToggle /></TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IconButton onClick={() => navigate("/manage-subscriptions/detail")}>
                        <img src="/static/images/eye_icon.svg" alt="" />
                      </IconButton>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubscriptionList;
